export const importAll = (context: __WebpackModuleApi.RequireContext) =>
  context.keys().map(context) as string[];
